import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
export default function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();

  while (output.length < targetLength) {
    output = '0' + output;
  }

  return sign + output;
}